import { render, staticRenderFns } from "./TransferShopDialog.vue?vue&type=template&id=24b12861&scoped=true"
import script from "./TransferShopDialog.vue?vue&type=script&lang=ts"
export * from "./TransferShopDialog.vue?vue&type=script&lang=ts"
import style0 from "./TransferShopDialog.vue?vue&type=style&index=0&id=24b12861&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b12861",
  null
  
)

export default component.exports